import Vue from "vue";
// "{0} is dead, but {1} is alive! {0} {2}".format("ASP", "ASP.NET")
if (!String.prototype.format) {
	String.prototype.format = function () {
		if (!this) return "";

		var args = arguments;
		return this.replace(/{(\d+)}/g, function (match, number) {
			return typeof args[number] != "undefined" ? args[number] : match;
		});
	};
}
if (!String.format) {
	String.format = function (format, args) {
		if (!format) return "";

		args = args || Array.prototype.slice.call(arguments, 1);
		return format.replace(/{(\d+)}/g, function (match, number) {
			return typeof args[number] != "undefined" ? args[number] : match;
		});
	};
}

export default {
	fn: {
		translate(value) {
			if (window.hub == null) return value;
			return window.hub.ui.versions.versioned(value, arguments && arguments.length > 1 ? arguments[1] : null);
		},
		createGuid() {
			let s4 = () => {
					return Math.floor((1 + Math.random()) * 0x10000)
						.toString(16)
						.substring(1);
				},
				s8 = () => {
					return s4() + s4();
				};

			return s8() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s8() + s4();
		},
		getChannelName(url) {
			const regex = /^https?:\/\/[^/]+\/([^/]+)/;
			const matches = regex.exec(url);
			if (matches && matches.length === 2) {
				return matches[1];
			}
			return null;
		},
		pushWindowHistoryState(departmentUrl){
			var currentURL = window.location.href;
			var index = currentURL.indexOf("?") !== -1 ? currentURL.indexOf("?") : currentURL.length;
			var channelName = this.getChannelName(currentURL);
			if (channelName.endsWith("/")) {
				channelName = channelName.slice(0, -1);
			}
			var newURL = channelName + "/" + departmentUrl + currentURL.substring(index);
			if(this.isInSubState(currentURL)) {
				window.history.replaceState({path: departmentUrl}, '', departmentUrl);
			} else {
				window.history.replaceState({path: newURL}, '', newURL);
			}
		},
		isInSubState(url) {
			if (url.charAt(url.length - 1) === "/") {
				return true;
			}
			const path = new URL(url).pathname;
			const pathArray = path.split('/');
			
			if (pathArray.length < 3) {
				return false;
			}
			
			return pathArray[2].length > 0;
		},
		/**
		 * Get a value based on a path. 
		 * @param {object} container object in which to lookup
		 * @param {string} path path to the value. In case a specific array index is needed use this format: Array.Index.Property 
		 * @returns the found value or null
		 */
		findValue(container, path) {
			
			if (container == null || path == null) return null;

			if (path.indexOf(".") !== -1) {
				let name = path.substring(0, path.indexOf(".")),
					obj = container[name],
					next = path.replace(name + ".", "");

				if (Array.isArray(obj) && isNaN(parseInt(next))) {
					// return list of values for this array
					let values = [];

					obj.forEach(entry => {
						values.push(this.findValue(entry, next));
					});

					if (values.length) {
						let total = values.length,
							str = values.slice(0, 3).join("<br />");

						if (total > 3) {
							str += "<br /><small class=\"bold\">" + this.translate("and_more_items", {
								1: total - 3
							}) + "</small>";
						}

						return str;
					}

					return "<span class=\"text-color-negative\">" + this.translate("no_items") + "</span>";
				} else {
					return this.findValue(obj, next);
				}
			}

			return container[path];
		},
		clearLastURLUpdate() {
			var currentURL = window.location.href;
			var index = currentURL.indexOf("?") !== -1 ? currentURL.indexOf("?") : currentURL.length;
			var channelName = currentURL.substring(0, index);
			if (channelName.endsWith("/")) {
				channelName = channelName.slice(0, -1);
			}
			var lastIndex = channelName.lastIndexOf("/");
			if (lastIndex !== -1 && lastIndex > channelName.indexOf("/")) {
				channelName = channelName.substring(0, lastIndex);
				var newURL = channelName + currentURL.substring(index);
				window.history.pushState({path: newURL}, '', newURL);
			}
		}
	}
}

export const ClickOutside = Vue.directive('click-outside', {
	bind: function (el, binding, vnode) {
		el.clickOutsideEvent = function (event) {
			// here I check that click was outside the el and his childrens
			if (!(el == event.target || el.contains(event.target))) {
				// and if it did, call method provided in attribute value
				vnode.context[binding.expression](event);
			}
		};
		document.body.addEventListener('click', el.clickOutsideEvent)
	},
	unbind: function (el) {
		document.body.removeEventListener('click', el.clickOutsideEvent)
	},
});